

import { Link } from "react-router-dom";
import Container from "../Container";

import {
    Search,
    ShoppingCart,
    UserRound,
    Menu,
    ChevronLeft,
    Phone,
    MapPin,
    Camera,
    SquarePlay,
    Send,
    HeartPulse,
    Truck,
    ShieldCheck,
    Headphones,
    Headset,
    Mail,
    RotateCcw,
    TruckElectric,
    Ambulance,
    CreditCard,
    BanknoteCheck,
} from "lucide-react";

const styles = `
  
  /* ===== Small heading / tabs ===== */
  .section { padding: 26px 0 0; }
  .section-head { border-bottom: 1px solid #ddebd7; margin-bottom: 13px; display: flex; align-items: flex-end; justify-content: space-between; gap: 16px; }
  .section-title { margin: 0 0 8px; padding-right: 10px; font-size: 16px; color: #4f7a24; font-weight: 900; position: relative; }
  .section-title::before { content: ''; position: absolute; right: 0; top: 2px; width: 3px; height: 18px; border-radius: 3px; background: #4dcc69; }
  .tabs { display: flex; gap: 6px; margin-bottom: 8px; overflow-x: auto; scrollbar-width: none; }
  .tabs::-webkit-scrollbar { display: none; }
  .tab { flex: 0 0 auto; border: 1px solid #caabd0; background: #fff; color: #832865; border-radius: 16px; padding: 7px 15px; font-size: 11px; }
  .tab.active { color: #fff; background: #ab83c3; border-color: #ab83c3; }


  /* ===== Categories ===== */
  .category-row { display: grid; grid-template-columns: repeat(8, 1fr); gap: 13px; padding: 6px 0 12px; }
  .category-item { text-align: center; }
  .category-circle { width: 67px; height: 67px; margin: auto; border-radius: 50%; background: linear-gradient(180deg,#f5f8f3,#e8f1e1); display: grid; place-items: center; font-size: 30px; border: 1px solid #e4eee0; }
  .category-item span { display: block; margin-top: 6px; font-size: 10px; color: #4f4f4f; line-height: 1.45; }

  .brand-row { display: grid; grid-template-columns: repeat(6, 1fr); gap: 14px; padding: 8px 0 15px; }
  .brand-circle { aspect-ratio: 1; border-radius: 50%; border: 4px solid currentColor; display: grid; place-items: center; text-align: center; padding: 12px; font-size: 11px; font-weight: 900; background: #fff; }
  .brand-1{color:#7d25c6}.brand-2{color:#e72525}.brand-3{color:#208344}.brand-4{color:#562721}.brand-5{color:#202020}.brand-6{color:#5b8a70}

  .offer-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
  .offer-card { min-height: 115px; border-radius: 11px; overflow: hidden; background: #f7f7f7; position: relative; padding: 17px; display: flex; flex-direction: column; justify-content: center; }
  .offer-card h3 { margin: 0; font-size: 14px; color: #444; }
  .offer-card strong { margin-top: 6px; font-size: 15px; color: #832865; }
  .offer-card button { width: fit-content; border: 0; background: #2d2d2d; color: #fff; border-radius: 18px; padding: 6px 14px; font-size: 9px; margin-top: 8px; }
  .offer-card::after { content: '✨'; position: absolute; left: 14px; bottom: 11px; font-size: 44px; opacity: .35; }

  /* ===== Articles ===== */
  .articles-wrap { border: 2px solid #9af0a5; background: #dfffe4; border-radius: 14px; padding: 11px; }
  .articles-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
  .article-card { background: #fff; border-radius: 11px; overflow: hidden; box-shadow: 0 2px 9px rgba(46, 120, 62, .08); }
  .article-image { height: 125px; display: grid; place-items: center; font-size: 53px; background: linear-gradient(135deg,#f4fbf5,#e9f7ee); }
  .article-body { padding: 10px; }
  .article-body h3 { margin: 0; color: #54852c; font-size: 12px; line-height: 1.6; }
  .article-body p { margin: 6px 0 0; color: #666; font-size: 9px; line-height: 1.9; }

  /* ===== About ===== */
  .about { border-top: 1px solid #e6e6e6; margin-top: 28px; padding: 22px 0 6px; text-align: right; }
  .about h2 { margin: 0 0 8px; font-size: 20px; color: #617f2a;font-family: 'IRANSansMedium'; }
  .about p { margin: 0; color: #666; font-size: 14px; line-height: 2.1;font-family: 'IRANSansMedium';text-align: justify; }

  /* ===== Service strip ===== */
  .service-strip { margin-top: 20px; border-radius: 14px; background: linear-gradient(90deg,#87a91f,#87a91fb8); color: #fff; display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 17px 20px; }
  .service { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 14px; text-align: center;color:#ffff; }
  .service svg { flex: 0 0 auto; }

  /* ===== Footer ===== */
  .footer { margin-top: 20px; border-top: 1px solid #eee;background: linear-gradient(180deg, #fbffff, #f2fbff); }
//   .footer { margin-top: 28px; border-top: 1px solid #eee; background:#8328650f; }
  .footer-main { padding: 25px 0; display: grid; grid-template-columns:1.1fr 4.5fr 3fr; gap: 28px; align-items: baseline;padding:0 20px; }
  .footer-brand p { margin: 12px 0 0; color: #777; font-size: 10px; line-height: 1.9; }
  .footer-brand a { display: flex;font-size: 20px;justify-content: center;margin: 10px;}
  .footer-brand .brand-copy { margin-right: 5px; }
  .footer-title { margin: 0 0 12px;font-size: 16px;
    color: #832865;
    border-bottom: 1px solid #832865;
    text-align: center; font-family: 'IRANSansMedium';}
  .footer-links { display: grid; gap: 8px; font-size: 14px; color: #777; font-family: 'IRANSansXFaNum-Regular';text-align: center; }
  .footer-links a { color: #706d66;font-size:12px; }
  .footer-links a:hover { color: #832865; }
  .footer-contact-list { display: grid; gap: 10px; color: #666; font-size: 14px; }
  .footer-contact-item { display: flex; align-items:center; gap: 7px; font-family: 'IRANSansXFaNum-Regular';font-size:12px;}
  .socials { display: flex; gap: 8px;justify-content: center; }
  .social { width: 40px; height: 40px; border: 1px solid #e7e7e7; border-radius: 50%; display: grid; place-items: center; color: #832865; }
  .footer-illustration { min-height: 180px; border-radius: 16px; display: grid; place-items: center; background: linear-gradient(180deg,#fbffff,#f2fbff); font-size: 72px; }
  .footer-bottom { border-top: 1px solid #efefef; padding: 10px 0; color: #999; font-size: 9px; }
  .footer-bottom-inner { display: flex; justify-content: space-between; gap: 10px;font-size: 14px; }
  .footer-motion{display: flex;justify-content: center;}
  .footer-access{display: flex;
    gap: 50px;
    justify-content: space-around;}

    .footer-cer{
display: flex;
    flex-direction: row;   
    gap: 20px;
    padding-top: 15px;
    align-items: center;
    justify-content: center;
}

.footer-cer-item{
border: 1px solid #eee;
    border-radius: 25px;
}

.footer-cer-item img{
    width: 100px;
    height: 100px;
    padding: 5px;
}
 

  /* ===== Responsive ===== */



  @media (max-width: 1200px) {
 .footer-main { grid-template-columns: repeat(3, 1fr);
  gap: 10px; }
    .footer-access {gap:0px}
}

  @media (max-width: 900px) {
    .header-inner { grid-template-columns: 1fr auto; grid-template-areas: 'brand actions' 'search search'; padding: 13px 0; gap: 12px; }
    .brand { grid-area: brand; justify-content: flex-start; }
    .header-actions { grid-area: actions; }
    .header-search { grid-area: search; }
    .nav-inner { overflow-x: auto; scrollbar-width: none; }
    .nav-inner::-webkit-scrollbar { display: none; }
    .nav-links { gap: 18px; }
    .nav-contact { display: none; }
    .hero-content { padding-right: 43%; }
    .hero-product { left: 6%; width: 205px; height: 205px; font-size: 90px; }
    .category-row { grid-template-columns: repeat(4, 1fr); }
    .product-row { grid-template-columns: 1fr; }
    .mini-ad { min-height: 100px; }
    .service-strip { grid-template-columns: repeat(3, 1fr); }
   

      .footer-main { grid-template-columns: repeat(2, 1fr); }
    .footer-illustration { min-height: 140px; }
    .footer-bottom-inner { flex-direction: column; align-items: center; text-align: center; }
    .footer-access {gap:0px}

       .footer-contact-list {   
    grid-template-columns: repeat(2, 1fr);
}

  }

  @media (max-width: 768px) {

      .footer-main { grid-template-columns: repeat(1, 1fr);padding-right: 0px;
    padding-left: 0px; }
.footer-motion{
border: 1px solid #eee;
    // padding: 10px;
    border-radius: 15px;
 
}

    .footer-access {
        gap: 0px;
        border: 1px solid #eee;
        padding: 10px;
        border-radius: 15px;
        margin:0 10px;
        //   margin-right:20px;
    }


.footer-contact{
    border: 1px solid #eee;
    padding: 20px;
    border-radius: 15px;
    margin: 10px;
      margin-right:20px;
}

   .footer-contact-list {   
    grid-template-columns: repeat(2, 1fr);
}

  
  }

  @media (max-width: 640px) {

    .section { padding-top: 20px; }
    .section-head { align-items: center; }
    .section-title { font-size: 14px; }
    .tabs { max-width: 65%; }


    .category-row { grid-template-columns: repeat(4, 1fr); gap: 8px; }
    .category-circle { width: 58px; height: 58px; font-size: 25px; }
    .category-item span { font-size: 9px; }

    .brand-row { grid-template-columns: repeat(3, 1fr); gap: 10px; }
    .brand-circle { font-size: 10px; }

    .offer-grid { grid-template-columns: 1fr; }
    .articles-grid { grid-template-columns: 1fr; }
    .article-image { height: 140px; }

    .service-strip { grid-template-columns: repeat(2, 1fr); padding: 14px 10px; }
    .service {font-size: 12px;
        min-height: 48px;
        justify-content: flex-start;
        align-items: center; }
    .service:last-child { grid-column: 1 / -1;justify-content: flex-start; }

    .footer-contact-list {   
    grid-template-columns: repeat(1, 1fr);
}

 
  }

 @media (max-width: 480px) {

 .footer-motion{
 margin-left:10px;
 }
   .footer-motion img{width:100%;}

}
`;


export default function Footer() {

    function AboutAndServices() {
        return (
            <section className="container">
                <div className="about">
                    <h2>فروشگاه آنلاین  کافه دارو </h2>
                    <p>
                        اگه نیاز به مکمل ورزشی و غذایی، محصولات آرایشی و بهداشتی، تجهیزات پزشکی و ورزشی داری به راحتی میتونی تو  کافه دارو  از دکتر داروساز، متخصص تغذیه و علوم ورزش مشاوره رایگان بگیری و محصولتو انتخاب و خرید کنی. همه محصولات هم لیبل اصالت بهداشت و کد پروانه بهداشتی دارن. پس امن، مطمئن و با قیمت مناسب از  کافه دارو  خرید کن.
                    </p>
                </div>
                <div className="service-strip">
                    <Link to="/contents/ارسال-رایگان">
                        <div className="service"><Truck size={28} /> شرایط ارسال رایگان </div>
                    </Link>

                    <Link to="/contents/تضمین-ارسال-اکسپرس">
                        <div className="service"><TruckElectric size={28} />
                            تضمین ارسال اکسپرس
                        </div>
                    </Link>

                    <Link to="/contents/تضمین-سلامت-و-اصالت-کالا">
                        <div className="service"><Ambulance size={28} />
                       تضمین سلامت و اصالت
                        </div>
                    </Link>

                    <Link to="/contents/تضمین-پرداخت-آسان">
                        <div className="service"><CreditCard size={28} />
                            تضمین پرداخت آسان
                        </div>
                    </Link>
                    <Link to="/contents/تضمین-بهترین-قیمت">
                        <div className="service"><BanknoteCheck size={28} />
                            تضمین بهترین قیمت
                        </div>
                    </Link>

                </div>
            </section>
        );
    }


    function Footer() {
        return (
            <footer className="footer">
                <div className="home-container footer-main">
                    <div className="footer-brand">
                        <a href="/" className="brand" style={{ justifyContent: "flex-start" }}>
                            <span className="brand-mark"><HeartPulse size={24} /></span>
                            <span className="brand-copy"><strong> فروشگاه آنلاین  کافه دارو </strong></span>
                        </a>

                        <div className="footer-motion">
                            <img src="images/footer/pic-motion-desk.gif" alt="cafedaru" />
                        </div>


                        <div className="socials">
                            <a href="#" className="social"><Send color="#29a7f5" size={25} /></a>
                            <a href="#" className="social"><SquarePlay size={25} /></a>
                            <a href="#" className="social"><Camera color="#f50f95" size={25} /></a>
                            <a href="#" className="social"><Phone color="#4da53b" size={25} /></a>
                        </div>
                    </div>

                    <div className="footer-access">

                        <div>
                            <h3 className="footer-title">دسترسی سریع</h3>
                            <div className="footer-links">

                                <Link to="/contents/درباره-کافه-دارو">درباره  کافه دارو </Link>
                           
                                  <Link to="">
                                نسخه آنلاین
                                </Link>
                                  <Link to="/پرسشهای-متداول">
                                    پرسش های متداول
                                </Link>
                           
                                {/* <Link to="/contents/راهنمای-خرید"> راهنمای خرید</Link> */}
                                {/* <Link to="/contents/مشاوره-تخصصی">مشاوره تخصصی</Link> */}
                                <Link to="/contents/قوانین-و-مقررات">قوانین و مقررات</Link>
                              


                            </div>
                        </div>

                        <div>
                            <h3 className="footer-title">خدمات مشتریان</h3>
                            <div className="footer-links">
                            

                                {/* <a href="/faq">ثبت نام</a>
                                <a href="/shipping">ورود</a>
                                <a href="/returns">فراموشی کلمه عبور</a> */}                              
                                <Link to="/dashboard/profile">پروفایل کاربری </Link>
                                <Link to="/contents/پیگیری-سفارشات">پیگیری سفارش</Link>
                                <Link to="/contents/باشگاه-مشتریان">باشگاه مشتریان </Link>
                                 <Link to="/contents/مشاوره-تخصصی">مشاوره تخصصی</Link>
                              

                            </div>
                        </div>


                    </div>

                    <div className="footer-contact">
                         <h3 className="footer-title">
                             <Link to="تماس-با-ما"> تماس با ما  </Link>
          
          </h3>
                        <div className="footer-contact-list">
                            <span className="footer-contact-item"><Headset size={14} /> ۲۴ ساعت شبانه‌روز پاسخگوی شما هستیم</span>
                            <span className="footer-contact-item"><Phone size={14} /> ۰۲۱-47586</span>
                            {/* <span className="footer-contact-item"><MapPin size={14} /> تهران، خیابان نمونه، پلاک ۱۲</span> */}
                            <span className="footer-contact-item"><Mail size={14} /> info@cafedaru.shop</span>
                        </div>
                        <div className="footer-cer">
                            <div className="footer-cer-item">
                                <img src="images/footer/logo-enamad.png" alt="cafedaru" />
                            </div>
                            <div className="footer-cer-item">
                                <img src="images/footer/logo-samandehi.png" alt="cafedaru" />
                            </div>

                        </div>
                    </div>


                </div>
                {/* <div className="container footer-illustration">🏥</div> */}
                <div className="footer-bottom">
                    <div className="container footer-bottom-inner">
                        <span>© {new Date().getFullYear()} تمامی حقوق برای  کافه دارو  محفوظ است.</span>
                        <span>طراحی و توسعه اختصاصی توسط گروه نرم‌افزاری  کافه دارو  | ۱۳۹۸–۱۴۰۵ </span>
                    </div>
                </div>
            </footer>
        );
    }



    return (
        <div className="home-container">
            <style>{styles}</style>

            <AboutAndServices />

            <Footer />

        </div>


    );
}

